const $ = require("jquery");
const jQuery = $;

window.jQuery = $;
window.$ = $;

require('./components/Utils/serialize_file_jquery.js');
require('./components/Utils/serialize_object_jquery.js');
require('bootstrap');

require('./select2/select2');

//---------------------------
// kernel, components & app proxy

const Kernel = require('./services/Kernel');
const Bindings  = require('./services/Bindings');
window.toastr = require('toastr/toastr');

window.Kernel = new Kernel();
window.Api = require('./app_proxy/Api');

window.Utils = require('./components/Utils/Utils');
window.Kernel.registerComponent('Form', require('./components/Form/Form'));
window.Form = require('./components/Form/Form');

import AsyncRenderer from './components/AsyncRenderer';
window.Kernel.registerComponent('AsyncRenderer', AsyncRenderer);

import FragmentPromotion from './components/FragmentPromotion';
window.Kernel.registerComponent('FragmentPromotion', FragmentPromotion);

import FormRegister from "./components/FormRegister";
window.Kernel.registerComponent('FormRegister', FormRegister);

import FormGroupPassword from "./components/FormGroupPassword";
window.Kernel.registerComponent('FormGroupPassword', FormGroupPassword);

import AddressAutocomplete from "./components/AddressAutocomplete/AddressAutocomplete";
window.Kernel.registerComponent('AddressAutocomplete', AddressAutocomplete);

import FragmentLinking from "./components/Linking/FragmentLinking";
window.Kernel.registerComponent("FragmentLinking", FragmentLinking);

import AsideErSidebar from "./components/AsideErSidebar";
window.Kernel.registerComponent('AsideErSidebar', AsideErSidebar);

import CartIcon from "./components/CartIcon";
window.Kernel.registerComponent("CartIcon", CartIcon);

import CustomerIcon from "./components/CustomerIcon";
window.Kernel.registerComponent("CustomerIcon", CustomerIcon);

import FileCollection from "./components/Form/FileCollection";
window.Kernel.registerComponent('FileCollection', FileCollection);

import FrontFileUpload from "./components/Form/FrontFileUpload";
window.Kernel.registerComponent('FrontFileUpload', FrontFileUpload);

import PopoverInfo from "./components/PopoverInfo";
window.Kernel.registerComponent("PopoverInfo", PopoverInfo);

import ComparatorCards from "./components/ComparatorCards";
window.Kernel.registerComponent('ComparatorCards', ComparatorCards);

import Field2FA from "./components/Field2FA";
window.Kernel.registerComponent('Field2FA', Field2FA);

$(document).on('keydown paste', 'input.readonly', (e) => {
  e.preventDefault();
});


window.mountApp = function () {
  const $body = $('body');
  // init components
  window.Kernel.mountComponents($body);
  // init global bindings
  new Bindings($body);
};

//---------------------------
